import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { DataTableDirective } from 'angular-datatables';
import { IAngularMyDpOptions, IMyDateModel } from 'angular-mydatepicker';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { take } from 'rxjs/internal/operators';
import { ModalConfig, ModalComponent } from '../modal/modal.component';
import { StorageService } from '../services/local-storage.service';
import { ShipmentService } from '../services/shipment.service';
import { UserManagementService } from '../services/user-management.service';
import { customValidator } from '../services/utils/customValidation';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.css']
})
export class UserManagementComponent implements OnInit {

  data;
  modalConfig: ModalConfig = { modalTitle: "" };
  @ViewChild('modal') private modalComponent: ModalComponent
  dtOptions: any = {};
  countries = []
  ctrl_ens_result = []
  ctrl_ens = []
  userSelected: any;
  form: FormGroup;
  formFilters: FormGroup;
  filtersActive: boolean = false;
  showCollapse: boolean = true;
  modalCreate: boolean = false;
  rowIndex: number = 0;
  @ViewChild(DataTableDirective, { static: false })
  private datatableElement: DataTableDirective;
  dtTrigger: Subject<any>;
  myDatePickerOptions: IAngularMyDpOptions = {
    dateRange: true,
    rtl: false,
    dateFormat: "dd/mm/yyyy"
  }
  datatableLanguge: any;
  fieldTextType: boolean = false;
  constructor(private formBuilder: FormBuilder, public userService: UserManagementService, private toastr: ToastrService,
    private zone: NgZone, public storage: StorageService, private translate: TranslateService,) {
    this.dtTrigger = new Subject()
    this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.dtOptions.language = event.translations.dataTable
        this.render(this.data)
      });

  }


  ngOnInit(): void {
    this.data = []
    this.userSelected = {}
    this.translate.get("dataTable").subscribe((language) => {
      this.datatableLanguge = language
      this.dtOptions = {
        responsive: true,
        retrieve: true,
        destroy: true,
        order: [[1, "asc"]],
        columnDefs: [{ targets: [0], orderable: false, searchable: false }],
        language: this.datatableLanguge,
        dom: "<'row'<'col-6 asasa'><'col-6'fB>>" +
          "<'row'<'col-12 mt-5 mb-5'tr>>" +
          "<'row'<'col-3'i><'col-6'p> <'col-3'l>>",
        buttons: [
          {
            text: '<i class="icon-excel"></i>',
            key: '1',
            titleAttr: 'excel',
            extend: 'excel',

          }
        ]
      };
      this.userService.getUsers().then(res => {
        this.render(res)
      })
    })
   

    this.form = this.formBuilder.group(
      {
        nameControl: [
          '', Validators.required],
        surnameControl: [
          '', Validators.required
        ],
        passwordControl: ['', Validators.required]

      }
    );

  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  clearDate(): void {
    // Clear the date using the patchValue function
    this.formFilters.patchValue({ myDate: null });
  }
  createUser() {
    var userName = this.storage.getCurrentUser().userName
    var body = {
      "fullName": this.form.value.nameControl || '',
      "userName": this.form.value.surnameControl || '',
      "userAlta": userName,
      "password": this.form.value.passwordControl || '',
    }
    this.userService.createUser(body).then((res) => {
      this.form.reset();

      this.data.push(res)
      return this.modalComponent.dismiss()
    }).catch(err => {
      return this.modalComponent.dismiss()
    })
  }
  async openModal(user, action, index) {
    if (action == "create") {
      this.modalCreate = true
      this.form.controls['nameControl'].setValue("");
      this.form.controls['surnameControl'].setValue("");
      this.form.controls['passwordControl'].setValue("");
      this.translate.get("userManagement").subscribe((text) => {
        this.modalConfig.modalTitle = text.createTitle
        this.modalConfig.modalSubTitle = text.createSubtitle

      });
    } else {
      this.modalCreate = false
      this.userSelected = user;
      this.rowIndex = index
      this.form.controls["passwordControl"].clearValidators()
      this.form.controls["passwordControl"].updateValueAndValidity();
      this.form.controls['nameControl'].setValue(user.fullName);
      this.form.controls['surnameControl'].setValue(user.userName);

      this.translate.get("userManagement").subscribe((text) => {
        this.modalConfig.modalTitle = text.editTitle
        this.modalConfig.modalSubTitle = text.editSubtitle

      });
    }

    return await this.modalComponent.open()
  }
  hideButton(): boolean {
    return true
  }
  async editUser() {

    var userName = this.storage.getCurrentUser().userName
    var body = {
      "fullName": this.form.value.nameControl || '',
      "userName": this.form.value.surnameControl || '',
      "password": this.form.value.passwordControl || '',
      "userAlta": userName,
      "id": this.userSelected.id
    }

    this.userService.editUser(body).then((res) => {
      this.form.reset();
      this.userSelected.fullName = res.fullName
      this.userSelected.userName = res.userName
      return this.modalComponent.dismiss()
    }).catch(err => {
      return this.modalComponent.dismiss()
    })

  }
  deleteUser() {
    this.userService.deleteUser(this.userSelected.id).then((res) => {
      this.form.reset();
      this.data.splice(this.rowIndex, 1)
      this.toastr.success('User Deleted');
      return this.modalComponent.dismiss()
    }).catch(err => {
      return this.modalComponent.dismiss()
    })
  }
  render(data) {
    this.zone.onMicrotaskEmpty.asObservable().pipe(
      take(1)
    ).subscribe(() => {

      this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next();
        this.data = data

      })
    });
  }

  ngAfterViewInit() {
    this.dtTrigger.next();

  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
}
